import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMapPinFlat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMapPinFlat"><Path d="M13 6.96C13 4.77 14.79 3 17 3C19.21 3 21 4.78 21 6.96C21 10.07 17.48 11.84 17.33 11.92L17 12.08L16.67 11.92C16.52 11.85 13 10.07 13 6.96ZM19.5 19.5H5.25C4.29 19.5 3.5 18.71 3.5 17.75C3.5 16.79 4.29 16 5.25 16H7.75V7.5H11.5V6H7.75V3H5.25C3.46 3 2 4.46 2 6.25V17.75C2 19.54 3.46 21 5.25 21H21V12H19.5V19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMapPinFlat;
